import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { ConfirmDialogService } from '../../../core/services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (service.isOpen() && service.options(); as options) {
      <div class="fixed inset-0 z-[1000] flex items-center justify-center px-4">
        <button
          type="button"
          class="fixed inset-0 bg-black/40"
          aria-label="Cerrar"
          (click)="cancel()"
        ></button>

        <div
          class="relative w-full max-w-sm rounded-[24px] bg-white p-6 shadow-xl"
          role="alertdialog"
          aria-modal="true"
          [attr.aria-label]="options.title"
        >
          <h2 class="text-lg font-bold text-secondary">{{ options.title }}</h2>
          <p class="mt-2 text-sm text-secondary-light">{{ options.message }}</p>
          <div class="mt-6 flex justify-end gap-3">
            <button type="button" class="app-btn app-btn--secondary" (click)="cancel()">
              {{ options.cancelLabel }}
            </button>
            <button
              type="button"
              class="app-btn"
              [class.app-btn--danger]="options.variant === 'danger'"
              [class.app-btn--primary]="options.variant !== 'danger'"
              (click)="confirm()"
            >
              {{ options.confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConfirmDialogComponent {
  protected readonly service = inject(ConfirmDialogService);

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.service.isOpen()) {
      this.cancel();
    }
  }

  protected confirm(): void {
    this.service.resolve(true);
  }

  protected cancel(): void {
    this.service.resolve(false);
  }
}
